import React from "react";
import { Link } from "react-router-dom";

const TodoListCard = ({ todoList = [] }) => {
    return (
        <div
            className="card shadow-sm border-0 mt-2"
            style={{
                width: "100%",
                maxWidth: "100%",
                minWidth: 0,
                height: "250px",
                borderRadius: "20px",
                overflow: "hidden",
                border: "1.5px solid #495057",
                boxShadow: "0 2px 8px rgba(0,0,0,0.12)"

            }}
        >
            {/* Header */}
            <div
                style={{
                    background: "#5e2c9e",
                    color: "#fff",
                    padding: "14px 18px",
                    fontWeight: "600",
                    fontSize: "18px",
                    flexShrink: 0
                }}
            >
                Todo List ({todoList.length})
            </div>

            {/* Body */}
            <div
                style={{
                    padding: "16px",
                    background: "#fff",
                    flex: 1,
                    overflowY: "auto",
                    overflowX: "hidden"
                }}
            >
                {todoList.length === 0 ? (
                    <div
                        className="d-flex flex-column justify-content-center align-items-center h-100 text-center"
                    >
                        <i
                            className="fa fa-calendar-check-o"
                            style={{
                                fontSize: "42px",
                                color: "#cbd5e1",
                                marginBottom: "12px"
                            }}
                        />
                        <p className="mb-0 text-muted">
                            No meetings or calls scheduled for today
                        </p>
                    </div>
                ) : (
                    todoList.map((item) => {
                        const isMeeting = item.type === "meetingUpdate";

                        return (
                            <Link
                                key={item.id}
                                // to={`/DatelsLeads/${item?.Lead?.id}`}
                                to={`/b2b/lead/activity/${item?.Lead?.id}`}
                                style={{ textDecoration: "none" }}
                            >
                                <div
                                    className="mb-3"
                                    style={{
                                        background: isMeeting ? "#f8fafc" : "#fff7ed",
                                        border: `1px solid ${isMeeting ? "#dbeafe" : "#fed7aa"
                                            }`,
                                        borderRadius: "12px",
                                        padding: "14px",
                                        cursor: "pointer"
                                    }}
                                >
                                    <div className="d-flex align-items-start gap-3">

                                        {/* Icon */}
                                        <div
                                            style={{
                                                width: "42px",
                                                height: "42px",
                                                minWidth: "42px",
                                                borderRadius: "50%",
                                                background: isMeeting
                                                    ? "#dbeafe"
                                                    : "#ffedd5",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}
                                        >
                                            <i
                                                className={
                                                    isMeeting
                                                        ? "fa fa-handshake-o"
                                                        : "fa fa-phone"
                                                }
                                                style={{
                                                    fontSize: "18px",
                                                    color: isMeeting
                                                        ? "#2563eb"
                                                        : "#ea580c"
                                                }}
                                            />
                                        </div>

                                        {/* Content */}
                                        <div className="flex-grow-1">
                                            <h6
                                                style={{
                                                    marginBottom: "6px",
                                                    color: "#1e293b",
                                                    fontWeight: "600"
                                                }}
                                            >
                                                {item?.Lead?.primaryContactName || "N/A"}
                                            </h6>

                                            <p
                                                style={{
                                                    marginBottom: "4px",
                                                    color: "#64748b",
                                                    fontSize: "13px"
                                                }}
                                            >
                                                {isMeeting ? "Meeting" : "Call"}
                                            </p>

                                            <p
                                                style={{
                                                    marginBottom: "4px",
                                                    color: "#475569",
                                                    fontSize: "13px"
                                                }}
                                            >
                                                <strong>Time:</strong>{" "}
                                                {new Date(
                                                    isMeeting
                                                        ? item.meetingDateTime
                                                        : item.callDateTime
                                                ).toLocaleTimeString("en-US", {
                                                    hour: "numeric",
                                                    minute: "2-digit",
                                                    hour12: true
                                                })}
                                            </p>

                                            {isMeeting ? (
                                                <>
                                                    <p className="mb-1 text-muted small">
                                                        Type: {item.meetingType}
                                                    </p>

                                                    {item.meetingType === "offline" && (
                                                        <p className="mb-0 text-muted small">
                                                            Venue: {item.meetingVenue}
                                                        </p>
                                                    )}
                                                </>
                                            ) : (
                                                <p className="mb-0 text-muted small">
                                                    Contact Type: {item.contactType}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        );
                    })
                )}
            </div>
        </div>
    );
};

export default TodoListCard;